export default __webpack_public_path__ + "static/media/doneTask.9a354051.png";